import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

export async function renewSSOTokens(
    instance: IPublicClientApplication,
    account: AccountInfo,
    loginRequest: {
        scopes: string[];
    }
): Promise<{ idToken: string; accessToken: string } | undefined> {
    try {
        const response = await instance.acquireTokenSilent({
            account,
            ...loginRequest,
            forceRefresh: true
        });
        return {
            idToken: response.idToken,
            accessToken: response.accessToken
        };
    } catch (e) {
        console.error('Failed to renew SSO tokens silently:', e);
        // If silent renewal fails, trigger an interactive redirect
        // so the user can re-authenticate
        try {
            await instance.acquireTokenRedirect({
                account,
                ...loginRequest
            });
        } catch (redirectError) {
            console.error(
                'Failed to renew SSO tokens via redirect:',
                redirectError
            );
        }
        return undefined;
    }
}
